window.addEventListener('DOMContentLoaded', () => {
  const handleRadioInputChange = (
    radioInput,
    annuallyItems,
    trimestreItems,
    radioLabels
  ) => {
    if (radioInput.value === 'annuelle') {
      showItems(annuallyItems);
      hideItems(trimestreItems);
    } else {
      hideItems(annuallyItems);
      showItems(trimestreItems);
    }

    radioLabels.forEach((label) => {
      label.classList.remove('text-violet', 'bg-white');
      label.classList.add('text-white');
    });

    if (radioInput.checked) {
      const label = radioInput.closest('.label-frequence');
      label.classList.remove('text-white');
      label.classList.add('text-violet', 'bg-white');
    }
  };

  const showItems = (items) => {
    items.forEach((item) => {
      item.style.display = 'block';
    });
  };

  const hideItems = (items) => {
    items.forEach((item) => {
      item.style.display = 'none';
    });
  };

  const frequencyLabels = document.querySelectorAll('.label-frequence');
  const annuallyItems = document.querySelectorAll('.annuelle');
  const trimestreItems = document.querySelectorAll('.trimestrielle');

  frequencyLabels.forEach((label) => {
    const radioInput = label.querySelector('input[type="radio"]');
    radioInput.addEventListener('change', () => {
      handleRadioInputChange(
        radioInput,
        annuallyItems,
        trimestreItems,
        frequencyLabels
      );
    });
  });

  const buttons = document.querySelectorAll('[aria-controls^="faq-"]');

  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      const ddElement = document.querySelector(
        `#${this.getAttribute('aria-controls')}`
      );
      ddElement.classList.toggle('hidden');
      ddElement.classList.toggle('none');
      button.classList.toggle('expanded');
      button.classList.toggle('collapsed');
    });
  });
  const buyingButtons = document.querySelectorAll('a.buying-button');
  buyingButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const eventId = button.getAttribute('data-fathomEvent');
      const price = button.getAttribute('data-prix') * 100;
      if (typeof fathom !== 'undefined') {
        // eslint-disable-next-line no-undef
        fathom.trackGoal(eventId, price);
      } else {
        console.error('Fathom is not defined');
      }
    });
  });
  const secondaryBuyingButtons = document.querySelectorAll(
    'a.secondary-buying-button'
  );
  secondaryBuyingButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const eventId = button.getAttribute('data-fathomEvent');
      const price = button.getAttribute('data-prix') * 100 + 9;
      if (typeof fathom !== 'undefined') {
        // eslint-disable-next-line no-undef
        fathom.trackGoal(eventId, price);
      } else {
        console.error('Fathom is not defined');
      }
    });
  });
});
